import React from "react";

const NOPermission = () => {
  return <div>NOPermission</div>;
};

export default NOPermission;
